import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setSession } = useAuth();

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { nav("/login", { replace: true }); return; }
      const session_id = decodeURIComponent(m[1]);
      // Strip the fragment so refresh doesn't re-trigger
      window.history.replaceState(null, "", window.location.pathname);
      try {
        const { data } = await axios.post(`${API}/auth/emergent-session`, { session_id });
        if (cancelled) return;
        setSession(data.token, data.user);
        // Customers → portal; anyone else → dashboard
        nav(data.user?.role === "customer" ? "/portal" : "/dashboard", { replace: true });
      } catch (e) {
        alert(e?.response?.data?.detail || "Google sign-in failed. Please try again.");
        nav("/login", { replace: true });
      }
    };
    run();
    return () => { cancelled = true; };
  }, [nav, setSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-4 border-[#FF6B00] border-t-transparent rounded-full mx-auto mb-4"></div>
        <div className="font-display text-lg">Signing you in…</div>
        <div className="text-xs text-zinc-500 mt-2">Please wait a moment.</div>
      </div>
    </div>
  );
}
